import { create, enforce, test } from "vest";

export default create((data = {}) => {
  test("firstName", () => {
    enforce(data.firstName)
      .isNotNull()
      .message("First name is required")
      .isNotBlank();
  });
  test("lastName", () => {
    enforce(data.lastName)
      .isNotNull()
      .message("Last name is required")
      .isNotBlank();
  });
});
